module.exports = __webpack_public_path__ + "assets/img/27_1251_big.7fc1a547.jpg";